import React from "react";
import { CONSTANT } from "../../../constant/Constant";
export default function Gallery({ gallery }) {
  const getImgUrl = (img) => {
    return `${CONSTANT.UI_URL}gallery/${img}`;
  };
  return (
    <>
      {gallery !== null && gallery !== undefined && (
        <div className="base h-auto w-full mt-15 mb-30">
          <div className="h-full w-screen flex justify-center items-center py-10 ">
            <div className="h-auto w-5/6 max-w-screen-2xl ">
              <p className="text-center md:text-left font-extrabold text-4xl font-mono">
                SIGNATURE MOMENTS FROM OUR TOP EVENTS
              </p>
            </div>
          </div>
          <div className="h-full w-screen flex justify-center items-center">
            <div className="h-full grid grid-flow-row lg:grid-flow-col gap-6 w-5/6 max-w-screen-2xl ">
              <div className="h-auto md:h-[750px] grid grid-rows-3 md:grid-rows-2 grid-col-10 grid-flow-col gap-6">
                <div className="sm:mx-0  mx-5 row-span-1 col-span-10 md:col-span-5 md:row-span-1 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50  rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt1}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp1}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5 rounded-3xl"></div>
                  <img
                    className="object-cover h-full rounded-3xl w-full"
                    src={getImgUrl(gallery.galImg1)}
                    alt=""
                  />
                </div>
                <div className="sm:mx-0 mx-5 row-span-1 col-span-10 md:col-span-5 md:row-span-1 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50  rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt2}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp2}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5 rounded-3xl"></div>
                  <img
                    className="object-cover h-full rounded-3xl w-full"
                    src={getImgUrl(gallery.galImg2)}
                    alt=""
                  />
                </div>
                <div className="sm:mx-0 mx-5 row-span-1 col-span-10 md:col-span-5 md:row-span-2 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50 rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt3}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp3}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5  rounded-3xl"></div>
                  <img
                    className="object-cover h-full w-full rounded-3xl"
                    src={getImgUrl(gallery.galImg3)}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-auto md:h-[750px] grid grid-rows-3 md:grid-rows-2 grid-col-10 grid-flow-col gap-4">
                <div className="sm:mx-0 mx-5 row-span-1 col-span-10 md:col-span-10 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50  rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt4}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp4}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5 rounded-3xl"></div>
                  <img
                    className="object-cover h-full rounded-3xl w-full"
                    src={getImgUrl(gallery.galImg4)}
                    alt=""
                  />
                </div>
                <div className="sm:mx-0 mx-5 row-span-1 col-span-10 md:col-span-4 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50 rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt5}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp5}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5  rounded-3xl"></div>
                  <img
                    className="object-cover h-full rounded-3xl w-full"
                    src={getImgUrl(gallery.galImg5)}
                    alt=""
                  />
                </div>
                <div className="sm:mx-0 mx-5 row-span-1 col-span-10 md:col-span-6 rounded-3xl relative">
                  <div className="absolute z-1 h-full w-full flex items-end hover:bg-black hover:opacity-50 rounded-3xl ">
                    <div className="p-8">
                      <p className="text-2xl text-white font-satoshi">
                        {gallery.txt6}
                      </p>
                      <p className="text-xl text-white font-mono ">
                        {gallery.desp6}
                      </p>
                    </div>
                  </div>
                  <div className="black h-full w-full opacity-30 bg-black absolute z-5  rounded-3xl"></div>
                  <img
                    className="object-cover h-full w-full rounded-3xl"
                    src={getImgUrl(gallery.galImg6)}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
